/** G.711 A-law，对齐 h5test / 网关 audio.go */

const ALAW_SEG_BASE = [8, 264, 528, 1056, 2112, 4224, 8448, 16896]
const ALAW_SEG_STEP = [16, 16, 32, 64, 128, 256, 512, 1024]
const ALAW_SEG_MAX = [248, 504, 1008, 2016, 4032, 8064, 16128, 32256]

export function resample(f32, fromRate, toRate) {
  if (fromRate === toRate) return f32
  const ratio = fromRate / toRate
  const n = Math.max(1, Math.floor(f32.length / ratio))
  const out = new Float32Array(n)
  for (let i = 0; i < n; i += 1) {
    const x = i * ratio
    const i0 = Math.floor(x)
    const i1 = Math.min(i0 + 1, f32.length - 1)
    out[i] = f32[i0] + (f32[i1] - f32[i0]) * (x - i0)
  }
  return out
}

function alawToLinear(a) {
  let v = a ^ 0x55
  let t = (v & 0x0f) << 4
  const seg = (v & 0x70) >> 4
  if (seg === 0) t += 8
  else if (seg === 1) t += 0x108
  else {
    t += 0x108
    t <<= seg - 1
  }
  return v & 0x80 ? t : -t
}

function linearToAlaw(sample) {
  let m = sample
  let sign = 0x80
  if (m < 0) {
    sign = 0
    m = -m
  }
  if (m < ALAW_SEG_BASE[0]) m = ALAW_SEG_BASE[0]
  let seg = 0
  while (seg < 7 && m > ALAW_SEG_MAX[seg]) seg += 1
  let quant = Math.floor((m - ALAW_SEG_BASE[seg] + (ALAW_SEG_STEP[seg] >> 1)) / ALAW_SEG_STEP[seg])
  if (quant < 0) quant = 0
  else if (quant > 15) quant = 15
  return (sign | (seg << 4) | quant) ^ 0x55
}

export function floatToAlaw(f32) {
  const out = new Uint8Array(f32.length)
  for (let i = 0; i < f32.length; i += 1) {
    const s = Math.max(-1, Math.min(1, f32[i]))
    const v = Math.max(-32768, Math.min(32767, Math.round(s * 32768)))
    out[i] = linearToAlaw(v)
  }
  return out
}

export function alawToFloat(u8) {
  const out = new Float32Array(u8.length)
  for (let i = 0; i < u8.length; i += 1) out[i] = alawToLinear(u8[i]) / 0x8000
  return out
}

export function toBase64(u8) {
  let s = ''
  for (let i = 0; i < u8.length; i += 0x8000) {
    s += String.fromCharCode.apply(null, u8.subarray(i, i + 0x8000))
  }
  return btoa(s)
}

export function fromBase64(b64) {
  const bin = atob(b64)
  const u8 = new Uint8Array(bin.length)
  for (let i = 0; i < bin.length; i += 1) u8[i] = bin.charCodeAt(i)
  return u8
}
